export type GetGooglePOIStylesDependingPOIFiltersParams = {
    hidePark: boolean;
    hideBusiness: boolean;
    hideAttraction: boolean;
    hideGovernment: boolean;
    hideMedical: boolean;
    hidePlaceOfWork: boolean;
    hideSchool: boolean;
    hideSport: boolean;
};
const getGooglePOIStylesDependingPOIFilters = ({
    hidePark,
    hideBusiness,
    hideAttraction,
    hideGovernment,
    hideMedical,
    hidePlaceOfWork,
    hideSchool,
    hideSport,
}: GetGooglePOIStylesDependingPOIFiltersParams): google.maps.MapTypeStyle[] => {
    const features = [
        { featureType: 'poi.attraction', hide: hideAttraction },
        { featureType: 'poi.business', hide: hideBusiness },
        { featureType: 'poi.government', hide: hideGovernment },
        { featureType: 'poi.medical', hide: hideMedical },
        { featureType: 'poi.park', hide: hidePark },
        { featureType: 'poi.place_of_worship', hide: hidePlaceOfWork },
        { featureType: 'poi.school', hide: hideSchool },
        { featureType: 'poi.sports_complex', hide: hideSport },
    ];

    const styles = features.map(({ featureType, hide }) => ({
        featureType,
        stylers: [
            {
                visibility: hide ? 'off' : 'on',
            },
        ],
    }));

    return styles;
};

export default getGooglePOIStylesDependingPOIFilters;
